var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "member_box" }, [
    _c("div", { staticClass: "search_criteria" }, [
      _c(
        "div",
        {
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInquire($event)
            },
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "输入订单号查询", clearable: "" },
            model: {
              value: _vm.queryData.orderNo,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "orderNo", $$v)
              },
              expression: "queryData.orderNo",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInquire($event)
            },
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "输入用户ID查询", clearable: "" },
            model: {
              value: _vm.queryData.memberId,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "memberId", $$v)
              },
              expression: "queryData.memberId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInquire($event)
            },
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "输入用户手机号查询", clearable: "" },
            model: {
              value: _vm.queryData.mobile,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "mobile", $$v)
              },
              expression: "queryData.mobile",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInquire($event)
            },
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "输入店铺名称查询", clearable: "" },
            model: {
              value: _vm.queryData.storeName,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "storeName", $$v)
              },
              expression: "queryData.storeName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInquire($event)
            },
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "输入外卖单号查询", clearable: "" },
            model: {
              value: _vm.queryData.takeoutOrderNo,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "takeoutOrderNo", $$v)
              },
              expression: "queryData.takeoutOrderNo",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInquire($event)
            },
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "输入定位查询", clearable: "" },
            model: {
              value: _vm.queryData.locate,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "locate", $$v)
              },
              expression: "queryData.locate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "选择订单状态", clearable: "" },
              model: {
                value: _vm.queryData.orderStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "orderStatus", $$v)
                },
                expression: "queryData.orderStatus",
              },
            },
            [
              _c("el-option", { attrs: { value: "-6", label: "不满意通过" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "-3", label: "已驳回" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "-1", label: "已取消" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "0", label: "已报名" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "1", label: "已提交" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "2", label: "待审核" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "3", label: "已完成" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "选择所属平台", clearable: "" },
              model: {
                value: _vm.queryData.platformCode,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "platformCode", $$v)
                },
                expression: "queryData.platformCode",
              },
            },
            [
              _c("el-option", { attrs: { value: "mt", label: "美团" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "ele", label: "淘宝闪购" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "jd", label: "京东外卖" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "选择订单类型", clearable: "" },
              model: {
                value: _vm.queryData.isPraise,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "isPraise", $$v)
                },
                expression: "queryData.isPraise",
              },
            },
            [
              _c("el-option", { attrs: { value: "1", label: "需评价订单" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "0", label: "无需评价订单" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "time-range-picker" },
        [
          _c("el-date-picker", {
            staticStyle: { width: "100%" },
            attrs: {
              type: "datetimerange",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "range-separator": "至",
              "start-placeholder": "抢单开始开始",
              "end-placeholder": "抢单开始结束",
              clearable: "",
            },
            model: {
              value: _vm.applyTimeRange,
              callback: function ($$v) {
                _vm.applyTimeRange = $$v
              },
              expression: "applyTimeRange",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "time-range-picker" },
        [
          _c("el-date-picker", {
            staticStyle: { width: "100%" },
            attrs: {
              type: "datetimerange",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "range-separator": "至",
              "start-placeholder": "下单开始时间",
              "end-placeholder": "下单结束时间",
              clearable: "",
            },
            model: {
              value: _vm.takeoutSubmitTimeRange,
              callback: function ($$v) {
                _vm.takeoutSubmitTimeRange = $$v
              },
              expression: "takeoutSubmitTimeRange",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "time-range-picker" },
        [
          _c("el-date-picker", {
            staticStyle: { width: "100%" },
            attrs: {
              type: "datetimerange",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "range-separator": "至",
              "start-placeholder": "创建开始时间",
              "end-placeholder": "创建结束时间",
              clearable: "",
            },
            model: {
              value: _vm.createTimeRange,
              callback: function ($$v) {
                _vm.createTimeRange = $$v
              },
              expression: "createTimeRange",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-buttons" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.onReset } }, [_vm._v("重置")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pull_down_box" },
        [
          _c("el-button", { attrs: { type: "info", plain: "" } }, [
            _c("img", {
              staticStyle: { width: "16px", height: "16px" },
              attrs: {
                src: require("@/assets/member/UserManage/icon1.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("img", {
              staticStyle: {
                width: "12px",
                height: "12px",
                "margin-left": "10px",
              },
              attrs: {
                src: require("@/assets/member/UserManage/icon2.png"),
                alt: "",
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "down_item" },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.onCheckBox },
                  model: {
                    value: _vm.checkList,
                    callback: function ($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "下单用户" } }, [
                        _vm._v("下单用户"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "手机号码" } }, [
                        _vm._v("手机号码"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "店铺名称" } }, [
                        _vm._v("店铺名称"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "下单平台" } }, [
                        _vm._v("下单平台"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "外卖单号" } }, [
                        _vm._v("外卖单号"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "订单金额" } }, [
                        _vm._v("订单金额"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "用户返现金额" } }, [
                        _vm._v("用户返现金额"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "平台收益" } }, [
                        _vm._v("平台收益"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "定位" } }, [
                        _vm._v("定位"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "订单类型" } }, [
                        _vm._v("订单类型"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "下单时间" } }, [
                        _vm._v("下单时间"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "抢单时间" } }, [
                        _vm._v("抢单时间"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "创建时间" } }, [
                        _vm._v("创建时间"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt10" },
                    [
                      _c("el-checkbox", { attrs: { label: "更新时间" } }, [
                        _vm._v("更新时间"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt20 table-wrapper" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, border: "", height: "100%" },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "orderNo",
                label: "订单号",
                align: "center",
                "min-width": "160",
              },
            }),
            _vm._v(" "),
            _vm.checkList.includes("下单用户")
              ? _c("el-table-column", {
                  attrs: {
                    label: "下单用户",
                    align: "center",
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "member-cell" }, [
                              _c("div", [
                                _vm._v(_vm._s(scope.row.memberName || "-")),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "member-id" }, [
                                _vm._v(
                                  "UID:" + _vm._s(scope.row.memberId || "-")
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1903579572
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("手机号码")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "mobile",
                    label: "手机号码",
                    align: "center",
                    "min-width": "120",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("店铺名称")
              ? _c("el-table-column", {
                  attrs: {
                    label: "店铺名称",
                    align: "center",
                    "min-width": "300",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "shop-cell" }, [
                              scope.row.coverPic
                                ? _c("img", {
                                    staticClass: "shop-img",
                                    attrs: { src: scope.row.coverPic, alt: "" },
                                  })
                                : _c("div", { staticClass: "shop-img" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "shop-info" }, [
                                _c("div", { staticClass: "shop-name" }, [
                                  _vm._v(_vm._s(scope.row.storeName || "-")),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tag-list" },
                                  _vm._l(
                                    [
                                      scope.row.hasFullRebate
                                        ? "满" +
                                          scope.row.fullAmount +
                                          "返" +
                                          scope.row.rebateAmount
                                        : "",
                                      scope.row.hasRebateRate
                                        ? "返实付" + scope.row.rebateRate
                                        : "",
                                      scope.row.hasMaxRebate
                                        ? "最高返" + scope.row.maxRebateAmount
                                        : "",
                                    ].filter(Boolean),
                                    function (item, idx) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: idx,
                                          staticClass: "activity-tag",
                                          attrs: {
                                            type: "danger",
                                            effect: "dark",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v(_vm._s(item))]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3137715919
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("下单平台")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "platformCode",
                    label: "下单平台",
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formatPlatform(scope.row.platformCode)
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    164405234
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("外卖单号")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "takeoutOrderNo",
                    label: "外卖单号",
                    align: "center",
                    "min-width": "150",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("订单金额")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "payAmount",
                    label: "订单金额",
                    align: "center",
                    "min-width": "100",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("用户返现金额")
              ? _c("el-table-column", {
                  attrs: {
                    label: "用户返现金额",
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.finalRebateAmount
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.finalRebateAmount)),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2895374364
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("平台收益")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "platformAmount",
                    label: "平台收益",
                    align: "center",
                    "min-width": "100",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("定位")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "locate",
                    label: "定位",
                    align: "center",
                    "min-width": "100",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("订单类型")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "isPraise",
                    label: "订单类型",
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  scope.row.isPraise === 1
                                    ? "需评价订单"
                                    : "无需评价订单"
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1993614898
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "orderStatus",
                label: "状态",
                align: "center",
                "min-width": "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.statusType(scope.row.orderStatus),
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.formatOrderStatus(scope.row.orderStatus)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _vm.checkList.includes("下单时间")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "takeoutSubmitTime",
                    label: "下单时间",
                    align: "center",
                    "min-width": "160",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("抢单时间")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "applyTime",
                    label: "抢单时间",
                    align: "center",
                    "min-width": "160",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("创建时间")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "创建时间",
                    align: "center",
                    "min-width": "160",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkList.includes("更新时间")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "updateTime",
                    label: "更新时间",
                    align: "center",
                    "min-width": "160",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-wrapper" },
      [
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.page,
            "page-sizes": [20, 30, 40],
            "page-size": _vm.size,
            layout: "total, prev, pager, next, sizes, jumper",
            total: _vm.total,
            background: "",
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }